import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Review = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7214 9.80235C11.9935 11.726 10.1343 13.0937 7.95567 13.0937C6.38838 13.0937 4.98642 12.3859 4.05203 11.2725L3.17197 11.7753C4.288 13.1875 6.016 14.0937 7.95567 14.0937C10.6315 14.0937 12.9046 12.369 13.7238 9.97058C14.5527 9.85727 15.1914 9.14639 15.1914 8.28633C15.1914 7.34744 14.4303 6.58633 13.4914 6.58633C12.5525 6.58633 11.7914 7.34744 11.7914 8.28633C11.7914 8.94805 12.1695 9.52146 12.7214 9.80235ZM11.8833 4.75637C10.949 3.62633 9.53645 2.90625 7.95567 2.90625C5.60417 2.90625 3.62484 4.49966 3.03848 6.66565C3.7179 6.88832 4.20859 7.52758 4.20859 8.28145C4.20859 9.22033 3.44748 9.98145 2.50859 9.98145C1.56971 9.98145 0.808594 9.22033 0.808594 8.28145C0.808594 7.51579 1.31476 6.86835 2.01073 6.65551C2.62293 3.93692 5.05216 1.90625 7.95567 1.90625C9.90876 1.90625 11.6472 2.82508 12.7624 4.25406L11.8833 4.75637Z"
      />
    </svg>
  )
})

export default Review
